// extracted by mini-css-extract-plugin
export default {"order-by-mobile__title":"order-by-mobile__title_k2NK3xid"};